

// // src/Loan/LoanCard.jsx
// import React, { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/loan/loanEmiSlice";
// import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
// import jsPDF from "jspdf";
// import Barcode from "react-barcode";
// import html2canvas from "html2canvas";
// import "../assets/Loan/LoanCard.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// // Utils
// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
// };
// const formatAmount = (amount) =>
//   !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

// const GroupLoanEmiCard = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();
//   const cardRef = useRef();

//   const { emis, loading: emiLoading, error: emiError } = useSelector(
//     (state) => state.loanEmi
//   );
//   const { loans, loading: loanLoading, error: loanError } = useSelector(
//     (state) => state.loanReport
//   );
//   const { profile } = useSelector((state) => state.userProfile);

//   const [company, setCompany] = useState(null);
//   const [photoUrl, setPhotoUrl] = useState(null);

//   const createdById = Number(localStorage.getItem("userId")) || 0;

//   // ✅ Fetch Profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ✅ Fetch Loan + Company
//   useEffect(() => {


//     if (loanId) {
//       dispatch(fetchLoanEmis(loanId));
//       if (loans.length === 0) dispatch(fetchAllLoans());
//     }

//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo) {
//             data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//           }
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Error fetching company:", err);
//       }
//     };
//     if (profile?.superAdminId) fetchCompany();

//     return () => dispatch(clearLoanEmis());
//   }, [dispatch, loanId, loans.length, profile?.superAdminId]);

//   const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
//   const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";

//   // ✅ Fetch Customer Photo (filtered by 'photo' docName)
//   useEffect(() => {

//           const branchId = Number(localStorage.getItem("userId")) || 0;

//     const fetchCustomerPhoto = async () => {
//       try {
//         if (loan?.customerId && profile?.superAdminId) {
//           const res = await fetch(
//             `https://payyug.in/api/list-kyc?userId=${loan.customerId}&superAdminId=${profile.superAdminId}&createdById=${branchId}`
//           );
//           const data = await res.json();
//           if (res.ok && data.documents?.length > 0) {
//             const photoDoc = data.documents.find(
//               (doc) => doc.docName?.toLowerCase() === "photo"
//             );
//             if (photoDoc?.docImage) {
//               setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
//             }
//           }
//         }
//       } catch (err) {
//         console.error("Failed to fetch customer photo:", err);
//       }
//     };

//     fetchCustomerPhoto();
//   }, [loan?.customerId, profile?.superAdminId, createdById]);

 


// const generatePDF = async () => {
//   const input = cardRef.current;
//   if (!input) return;

//   const pdf = new jsPDF("p", "mm", "a4");
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const canvas = await html2canvas(input, {
//     scale: 2,
//     useCORS: true,
//     allowTaint: true,
//     scrollY: -window.scrollY,
//   });

//   const imgWidth = pageWidth - 20;      // 10mm left + 10mm right margin
//   const pageImageHeight = pageHeight - 20; // 10mm top + 10mm bottom margin

//   const totalImageHeight = (canvas.height * imgWidth) / canvas.width;

//   let renderedHeight = 0;

//   while (renderedHeight < totalImageHeight) {

//     // CREATE TEMPORARY CANVAS FOR EACH PAGE
//     const pageCanvas = document.createElement("canvas");
//     pageCanvas.width = canvas.width;
//     pageCanvas.height =
//       (pageImageHeight * canvas.width) / imgWidth;

//     const ctx = pageCanvas.getContext("2d");

//     // COPY PART OF FULL IMAGE → PAGE IMAGE
//     ctx.drawImage(
//       canvas,
//       0,
//       (renderedHeight * canvas.width) / imgWidth,
//       canvas.width,
//       pageCanvas.height,
//       0,
//       0,
//       canvas.width,
//       pageCanvas.height
//     );

//     const pageImgData = pageCanvas.toDataURL("image/png");
//     const pageImgHeight = (pageCanvas.height * imgWidth) / canvas.width;

//     if (renderedHeight === 0) {
//       // FIRST PAGE
//       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
//     } else {
//       // OTHER PAGES
//       pdf.addPage();
//       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
//     }

//     renderedHeight += pageImageHeight;
//   }

//   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// };






//   if (loanLoading || emiLoading)
//     return <div className="branch-loan-card-container">Loading...</div>;
//   if (loanError || emiError)
//     return (
//       <div className="branch-loan-card-container">{loanError || emiError}</div>
//     );
//   if (!loan)
//     return (
//       <div className="branch-loan-card-container">
//         No loan found for Loan ID {loanId}
//       </div>
//     );

//   return (
//     <div>
//       <div className="branch-loan-card-container" ref={cardRef}>
//         {/* Header */}
//         <header className="branch-loan-card-header">
//           <div className="branch-loan-card-logo-box">
//             {company?.logoUrl && (
//               <img
//                 src={company.logoUrl}
//                 alt="Logo"
//                 className="branch-loan-card-logo"
//               />
//             )}
//           </div>

//           <div className="branch-loan-card-details-box">
//             <h2>{company?.name || "Company Name"}</h2>
//             <p>
//               <strong>CIN:</strong> {company?.cin || "-"}
//               <br />
//               <strong>Regt. Office:</strong> {company?.address || "-"}
//               <br />
//               <strong>Website:</strong> {company?.domain || "-"}
//               <br />
//               <strong>Contact:</strong> {company?.contact || "-"}
//               <br />
//               <strong>Email:</strong> {company?.email || "-"}
//             </p>
//           </div>

//           <div className="branch-loan-card-qr-box">
//             <img
//               // src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${loanId}`}
//               src="/payyug_scanner2.jpg"
//               alt="QR Code"
//               className="branch-loan-card-qr"
//             />
//           </div>
          
//         </header>

//         {/* Title */}
//         <div className="branch-loan-card-title-section">
//           <div className="branch-loan-card-barcode-top">
//             <Barcode
//               value={loanId}
//               height={40}
//               displayValue={true}
//               fontSize={14}
//               margin={0}
//             />
//           </div>
//           <h3 className="branch-loan-card-title">Loan EMI Card</h3>
//         </div>

//         {/* Loan & Customer Details */}
//         <div className="branch-loan-card-loan-details">
//           <table className="branch-loan-card-detail-table">
//             <tbody>
//               <tr>
//                 <td>
//                   <strong>Customer Name:</strong> {loan.userName || "-"}
//                 </td>
//                 <td>
//                   <strong>Loan ID:</strong>{" "}
//                   {loan.loanAccountNumber || loan.loanNumber}
//                 </td>
//                 <td rowSpan="4" className="branch-loan-card-photo-cell">
//                   <img
//                     src={
//                       photoUrl ||
//                       "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
//                     }
//                     alt="Customer"
//                     className="branch-loan-card-photo"
//                   />
//                 </td>
//               </tr>
//               {/* <tr>
//                 <td>
//                   <strong>Contact No:</strong> {loan.contactNo || "-"}
//                 </td>
//                 <td>
//                   <strong>Guardian Name:</strong> {loan.guardianName || "-"}
//                 </td>
//               </tr> */}
//               <tr>
//                 <td>
//                   <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
//                 </td>
//                 <td>
//                   <strong>Plan Name:</strong>{" "}
//                   {loan.loanService || loan.loanService || "-"}
//                 </td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Number of EMI:</strong> {emis.length}
//                 </td>
//                 <td>
//                   <strong>EMI Amount:</strong>{" "}
//                   {formatAmount(emiAmountFromSchedule)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           <div className="branch-loan-card-branch-info">
//             <p>
//               <strong>Branch : </strong> {profile?.branchName || "-"}
//             </p>
//             <p>
//               <strong>Date : </strong> {new Date().toLocaleDateString("en-GB")}
//             </p>
//           </div>
//         </div>

//         {/* EMI Table */}
//         <section className="branch-loan-card-table-section">
//           <h4>EMI Schedule Terms</h4>
//           <table className="branch-loan-card-table">
//             <thead>
//               <tr>
//                 <th>Sr. No</th>
//                 <th>Loan EMI Date</th>
//                 <th>Interest</th>
//                 <th>Principal</th>
//                 <th>EMI</th>
//                 <th>Receiving Date</th>
//                 <th>Received Amt</th>
//                 <th>Staff Sign</th>
//                 <th>Member Sign</th>
//               </tr>
//             </thead>
//             <tbody>
//               {emis.map((emi, idx) => (
//                 <tr key={idx}>
//                   <td>{idx + 1}</td>
//                   <td>{formatDate(emi.dueDate)}</td>
//                   <td>{formatAmount(emi.interestComponent)}</td>
//                   <td>{formatAmount(emi.principalComponent)}</td>
//                   <td>{formatAmount(emi.emiAmount)}</td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </section>

//         {/* Footer */}
//         <footer className="branch-loan-card-footer">
//           <div>
//             Member Signature
//             <br />
//             (सदस्य के हस्ताक्षर)
//           </div>
//           <div>
//             Spouse Signature
//             <br />
//             (जीवनसाथी के हस्ताक्षर)
//           </div>
        
//           <div>
//             Branch Seal With Signature
//             <br />
//             (शाखा मोहर के साथ हस्ताक्षर)
//           </div>
//         </footer>
//       </div>

//       {/* PDF Button */}
//       <div style={{ textAlign: "center" }}>
//         <button onClick={generatePDF} className="branch-loan-card-download-btn">
//           📄 Download PDF
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GroupLoanEmiCard;




import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import jsPDF from "jspdf";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanCard.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";

/* ===================== Utils ===================== */
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
};

const formatAmount = (amount) =>
  !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

/* ===================== Component ===================== */
const GroupLoanEmiCard = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();
  const cardRef = useRef();

  const location = useLocation();
  const loan = location.state?.loan;

  const { profile } = useSelector((state) => state.userProfile);

  const [emis, setEmis] = useState([]);
  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
    const [customerDetails,setCustomerDetails]=useState(null);

    const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  const branchId = Number(localStorage.getItem("userId")) || 0;

  /* ===================== Fetch Profile ===================== */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  console.log("lonas",loan)

  /* ===================== Fetch Company ===================== */
  useEffect(() => {
    if (!profile?.superAdminId) return;

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
           if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          if(data.qrCodeImage){
            data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };

    fetchCompany();
  }, [profile?.superAdminId]);

  /* ===================== Fetch EMI List ===================== */
  useEffect(() => {
    if (!loanId || !profile?.superAdminId) return;

    const fetchEmis = async () => {
      try {
        const res = await axios.get(
          // `https://payyug.in/api/group-loan/emi/list?loanId=${loanId}`,
          `https://payyug.in/api/group-loan/emi/list-filter?loanId=${loanId}`,
          {
            params: {
               superAdminId:profile.superAdminId,
              branchId:loan.branchId,
              grouploanAccountId:loan.id,
              limit:100,
            },
          }
        );
        console.log("emis",res.data)
        setEmis(res.data?.data || []);
      } catch (err) {
        console.error("Fetch EMI Error:", err);
        setEmis([]);
      }
    };

    fetchEmis();
  }, [loanId, profile?.superAdminId]);

  /* ===================== Fetch Customer Photo ===================== */
  useEffect(() => {
    if (!loan?.member?.userId || !profile?.superAdminId) return;

    const fetchCustomerDetails = async () => { 
       try {
            const res = await fetch(
              `https://payyug.in/api/customers-get-userId?userId=${loan.member.userId}&branchId=${branchId}`
            );

            const data = await res.json();
             console.log("Customer API Response:", data);
            setCustomerDetails(data.data);
          } catch (err) {
            console.error("Customer fetch error:", err);
          }
    };
    const fetchCustomerPhoto = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/list-kyc?userId=${loan.member.userId}&superAdminId=${profile.superAdminId}&createdById=${branchId}`
        );
        const data = await res.json();
        if (res.ok && data.documents?.length > 0) {
          const photoDoc = data.documents.find(
            (doc) => doc.docName?.toLowerCase() === "photo"
          );
          if (photoDoc?.docImage) {
            setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
          }
        }
      } catch (err) {
        console.error("Failed to fetch customer photo:", err);
      }
    };

    fetchCustomerDetails();
    fetchCustomerPhoto();
  }, [loan?.customerId, profile?.superAdminId, branchId]);

  
  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Group Loan Card`
        );

        const dataArray = res?.data?.data?.[0] || [];


        if (dataArray && dataArray.file) {
          const cleanSealPath = dataArray.file.replace(/^images\//, "");
          setBranchSealUrl(`https://payyug.in/${cleanSealPath}`);
        } else {
          setBranchSealUrl(null);
        }

        if (dataArray && dataArray.type) {
          const cleanSignPath = dataArray.type.replace(/^images\//, "");
          setBranchSignUrl(`https://payyug.in/${cleanSignPath}`);
        } else {
          setBranchSignUrl(null);
        }

      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  /* ===================== Derived Values ===================== */
  const emiAmountFromSchedule =
    emis && emis.length > 0 ? emis[0].emiAmount : 0;

  /* ===================== PDF ===================== */
  const generatePDF = async () => {
    const input = cardRef.current;
    if (!input) return;

    const downloadBtn = document.querySelector(
      ".branch-loan-card-download-btn",
    );
    if (downloadBtn) downloadBtn.style.display = "none";

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 10;
    const contentWidth = pageWidth - margin * 2;
    const contentHeight = pageHeight - margin * 2;

    const canvas = await html2canvas(input, {
      scale: 2, 
      useCORS: true,
      backgroundColor: "#ffffff",
      scrollY: -window.scrollY,
    });

    const imgWidth = canvas.width;
    const pixelPageHeight = (imgWidth * contentHeight) / contentWidth;

    let heightLeft = canvas.height;
    let sY = 0;

  
    const targetElements = input.querySelectorAll(".print-row");
    let breakPoints = [];

    targetElements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const inputRect = input.getBoundingClientRect();
      const relativeTop = rect.top - inputRect.top;

      const canvasTop = relativeTop * 2;
      breakPoints.push(canvasTop);
    });

    while (heightLeft > 0) {
      let sHeight = pixelPageHeight;

      if (heightLeft > pixelPageHeight) {
        const expectedPageEnd = sY + pixelPageHeight;
        let bestBreakPoint = sY + pixelPageHeight;

        for (let i = 0; i < breakPoints.length; i++) {
          if (breakPoints[i] > sY && breakPoints[i] < expectedPageEnd) {
            bestBreakPoint = breakPoints[i];
          }
        }

        if (bestBreakPoint !== sY + pixelPageHeight) {
          sHeight = bestBreakPoint - sY;
        }
      } else {
        sHeight = heightLeft;
      }

      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = imgWidth;
      pageCanvas.height = pixelPageHeight;

      const ctx = pageCanvas.getContext("2d");

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

      ctx.drawImage(canvas, 0, sY, imgWidth, sHeight, 0, 0, imgWidth, sHeight);

      const pageImgData = pageCanvas.toDataURL("image/jpeg", 1.0);
      const displayHeight_mm = contentHeight;

      if (sY > 0) pdf.addPage();

      pdf.addImage(
        pageImgData,
        "JPEG",
        margin,
        margin,
        contentWidth,
        displayHeight_mm,
      );

      sY += sHeight;
      heightLeft -= sHeight;
    }

    if (downloadBtn) downloadBtn.style.display = "block";

    pdf.save(`${loan?.memberName}_GroupLoanCard.pdf`);
  };

  /* ===================== Safety ===================== */
  if (!loan) {
    return (
      <div className="branch-loan-card-container">
        No loan found for Loan ID {loanId}
      </div>
    );
  }

  /* ===================== UI (UNCHANGED) ===================== */
  return (
    <div>
      <div className="branch-loan-card-container" ref={cardRef}>
        {/* Header */}
        <header className="branch-loan-card-header">
          <div className="branch-loan-card-logo-box">
            {company?.logoUrl && (
              <img
                src={company.logoUrl}
                alt="Logo"
                className="branch-loan-card-logo"
              />
            )}
          </div>

          <div className="branch-loan-card-details-box">
            <h2>{company?.name || "Company Name"}</h2>
            <p>
              <strong>CIN:</strong> {company?.cin || "-"}
              <br />
              {/* <strong>Regt. Office:</strong>*/} {company?.address || "-"}
              <br />
              <strong>Website:</strong> {company?.domain || "-"}
              <br />
              <strong>Contact:</strong> {company?.contact || "-"}
              <br />
              <strong>Email:</strong> {company?.email || "-"}
            </p>
          </div>

          <div className="branch-loan-card-qr-box">
            <img
              src={company?.qrCodeUrl}
              alt="QR Code"
              className="branch-loan-card-qr"
            />
          </div>
        </header>

        {/* Title */}
        <div className="branch-loan-card-title-section">
          <div className="branch-loan-card-barcode-top">
            <Barcode value={loanId} height={40} displayValue fontSize={14} />
          </div>
          <h3 className="branch-loan-card-title">Group Loan EMI Card</h3>
        </div>

        {/* Loan Details */}
        <div className="branch-loan-card-loan-details">
          <table className="branch-loan-card-detail-table">
            <tbody>
              <tr>
                <td>
                  <strong>Member Name:</strong> {loan.memberName|| "-"}
                </td>
                <td>
                  <strong>Loan Account No:</strong>{" "}
                  {loan.loanAccountNumber || loan.loanNumber}
                </td>
                <td rowSpan="4" className="branch-loan-card-photo-cell">
                  <img
                    src={
                      photoUrl ||
                      "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
                    }
                    alt="Customer"
                    className="branch-loan-card-photo"
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <strong>Loan Type:</strong>{" "}
                  {loan.loanType}
                </td>
                <td>
                  <strong>Loan Amount:</strong>{" "}
                  {formatAmount(loan.loanAmount)}
                </td>
              </tr>

              <tr>
                <td>
                  <strong>Number of EMI:</strong> {emis.length}
                </td>
                <td>
                  <strong>EMI Amount:</strong>{" "}
                  {formatAmount(emiAmountFromSchedule)}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Group Name:</strong>{" "}
                  {loan.groupName || "-"}
                </td>
                <td colSpan={2}>
                  <strong>Address: </strong>{customerDetails?.address}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="branch-loan-card-branch-info">
            <p>
              <strong>Branch :</strong> {profile?.branchName || "-"}
            </p>
            <p>
              <strong>Date :</strong>{" "}
              {loan?.loanAppliedDate
                ? new Date(loan?.loanAppliedDate).toLocaleDateString("en-GB")
                : new Date().toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        {/* EMI Table */}
        <section className="branch-loan-card-table-section">
          <h4>EMI Schedule Terms</h4>
          <table className="branch-loan-card-table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Loan EMI Date</th>
                {loan?.loanType!=="FIXED" && (
                  <>
                <th>Interest</th>
                <th>Principal</th>
                  </>
                )}
                <th>EMI</th>
                {loan?.loanType!=="FIXED" && (
                  <th>Outstanding</th>
                )}
                <th>Receiving Date</th>
                <th>Received Amt</th>
                <th>Staff Sign</th>
                <th>Member Sign</th>
              </tr>
            </thead>
            <tbody>
              {emis.map((emi, idx) => (
                <tr key={idx} className="print-row">
                  <td>{idx + 1}</td>
                  <td>{formatDate(emi.dueDate)}</td>
                  {loan?.loanType!=="FIXED" && (
                    <>
                  <td>{formatAmount(emi.interestComponent)}</td>
                  <td>{formatAmount(emi.principalComponent)}</td>
                    </>
                  )}
                  <td>{formatAmount(emi.emiAmount)}</td>
                   {loan?.loanType!=="FIXED" && (
                  <td>{formatAmount(emi.outstanding)}</td>
                   )}
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* Footer */}
        <footer className="branch-loan-card-footer print-row">
          <div className="box-size">
            Member Signature
            <br />
            (सदस्य के हस्ताक्षर)
            <div className="border-line"></div>
          </div>
          <div className="box-size">
            Spouse Signature
            <br />
            (जीवनसाथी के हस्ताक्षर)
            <div className="border-line"></div>
          </div>
          <div className="footer-seal-sign box-size">
            Branch Seal With Signature
            <br />
            (शाखा मोहर के साथ हस्ताक्षर)
            <div className="border-line"></div>
          {branchSealUrl && (
              <div className="footer-seal">
                <img src={branchSealUrl} alt="Seal" />
              </div>
            )}
            
            {branchSignUrl && (
              <div className="footer-sign">
                <img src={branchSignUrl} alt="Signature" />
              </div>
            )}
          </div>
        </footer>
      </div>

      <div style={{ textAlign: "center" }}>
        <button
          onClick={generatePDF}
          className="branch-loan-card-download-btn"
        >
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};

export default GroupLoanEmiCard;